export default "__VITE_ASSET__BStlhAFg__"